import store from '../../store'
import {updateProjectRequest} from '../../actions/projects'

//Takes full project object

export function updateProject(project,showToast){

	return store.dispatch(updateProjectRequest(project,showToast))
}
